import { Button } from '@/ui-kit'
import { ReactNode } from 'react'
import { RestrictedWorker } from '../api/models'
import { LogInLinkTooltip } from './LogInLinkTooltip'

export const STATUS_FORMATTER = (authLink: string) =>
  function render(isConfirmed: boolean, isLoading: boolean) {
    if (isLoading) {
      return (
        <span key="ch" className="transition-colors max-mobile:text-xs">
          Check In Progress
        </span>
      )
    }

    return isConfirmed ? (
      <span key="au" className="text-[var(--colorGreen)] transition-colors max-mobile:text-xs">
        Authenticated
      </span>
    ) : (
      <LogInLinkTooltip key="n-a" link={authLink} />
    )
  }

export const COLUMN_DEFS = ({
  resourceId,
  statusFormatter,
  isConfirmLoading,
  isLoadingWorkerId,
  onConfirmCallback
}: {
  resourceId: string
  statusFormatter: (isConfirmed: boolean, isLoading: boolean) => ReactNode
  isConfirmLoading: boolean
  isLoadingWorkerId?: string
  onConfirmCallback: (props: { resourceId: string; workerId: string }) => void
}) => [
  {
    name: 'Status',
    cellClassName: 'w-[250px]',
    value: (worker: RestrictedWorker) => (
      <>{statusFormatter(worker.confirmed, isLoadingWorkerId === worker.id && isConfirmLoading) || ''}</>
    )
  },
  {
    name: 'Action',
    cellClassName: 'w-[250px]',
    value: ({ confirmed, id, type }: RestrictedWorker) => (
      <div className="flex justify-end pr-4">
        {!confirmed && (
          <Button
            className="w-full"
            variant="bordered"
            size="small"
            isLoading={isLoadingWorkerId === id && isConfirmLoading}
            isDisabled={type.toLowerCase() !== 'extension'}
            onClick={() => onConfirmCallback({ resourceId, workerId: id })}
          >
            {type.toLowerCase() === 'extension' ? 'Confirm Authentication' : 'Available soon...'}
          </Button>
        )}
      </div>
    ),
    mobileRender: ({ confirmed, type, id }: RestrictedWorker) => (
      <div className="mt-4 flex justify-end">
        {!confirmed && (
          <Button
            className="w-full"
            variant="bordered"
            size="small"
            isLoading={isLoadingWorkerId === id && isConfirmLoading}
            isDisabled={type.toLowerCase() !== 'extension'}
            onClick={() => onConfirmCallback({ resourceId, workerId: id })}
          >
            {type.toLowerCase() === 'extension' ? 'Confirm Authentication' : 'Available soon...'}
          </Button>
        )}
      </div>
    )
  }
]
